import { gql } from 'graphql-request';
import { graphqlClient } from '../client';

/**
 * GraphQL mutation for deleting a pricing metric
 */
const DELETE_PRICING_METRIC_MUTATION = gql`
  mutation DeletePricingMetric($id: ID!) {
    deletePricingMetric(id: $id) {
      id
      success
      message
    }
  }
`;

/**
 * Type for the delete pricing metric response
 */
export interface DeletePricingMetricResponse {
  deletePricingMetric: {
    id: string;
    success: boolean;
    message: string;
  };
}

/**
 * GraphQL mutation to delete a pricing metric
 * 
 * @param id The ID of the pricing metric to delete
 * @returns Response containing the deletion status
 */
export async function deletePricingMetricMutation(
  id: string
): Promise<DeletePricingMetricResponse> {
  try {
    console.log(`🔄 [GraphQL] Deleting pricing metric: ${id}`);
    
    // Execute the GraphQL mutation
    const response = await graphqlClient.request<DeletePricingMetricResponse>(
      DELETE_PRICING_METRIC_MUTATION,
      { id }
    );
    
    console.log('✅ [GraphQL] Pricing metric deletion response:', response);
    
    return response;
  } catch (error) {
    console.error('❌ [GraphQL] Error deleting pricing metric:', error);
    throw error;
  }
}
